/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../../dashboard/queryService/ResultItem',
	'../../dashboard/queryService/QueryResultColumn',
	'../../../widgets/livewidget/nls/StringResources',
	'underscore',
	'../../../apiHelpers/SlotAPIHelper'
], (ResultItem, QueryResultColumn, StringResources, _, SlotAPIHelper) => {

	class DataQueryResultItem extends ResultItem {
		constructor(dataItemObject, slots) {
			super(dataItemObject);
			this._slots = slots;
			this.getRowCount = this.getTupleCount.bind(this);
		}

		getDataItemList() {
			if (!this._dataItemList) {
				this._dataItemList = [];
				const id = this.getTupleHeaderId();
				let dataItemInfo = this._slots.getMappingInfo(id);
				if (!dataItemInfo) {
					// Could be a slot with nested data items in result item, otherwise skip
					const slot = this._slots.getSlot(id);
					let dataItemList = slot && slot.getDataItemList();
					if (dataItemList && this.isMultiMeasureValue(dataItemList)) {
						// TODO Temporary solution for multiMeasureValue data item.
						dataItemList = [new QueryResultColumn({
							u: SlotAPIHelper.MULTI_MEASURES_VALUE,
							d: StringResources.get('ValuesCaption')
						}).getAPI()];
					}
					if (!dataItemList) {
						// Handle data item generated internally, such as contextual grid to get data with columns referenced by tab filters
						const columnHeaders = this.getTupleHeaders()[0];
						dataItemList = columnHeaders && _.map(columnHeaders, columnHeader => (new QueryResultColumn(columnHeader)).getAPI());
					}
					this._dataItemList.push(...dataItemList);
				} else {
					this._dataItemList.push(dataItemInfo.dataItem);
				}
			}

			return this._dataItemList;
		}

		isMultiMeasureValue(dataItemList) {
			if (dataItemList.length < 2) {
				return false;
			}
			const list = _.filter(dataItemList, (dataItem) => {
				return (dataItem.getType() === 'fact');
			});

			return (list.length > 1);
		}
	}

	return DataQueryResultItem;
});
